require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-6-l-exh-jda-nlb-usl-3-z-4-m-xi-jy.json") })
        }
      }, "path---news-c-6-l-exh-jda-nlb-usl-3-z-4-m-xi-jy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-6-l-exh-jda-nlb-usl-3-z-4-m-xi-jy!./.cache/json/news-c-6-l-exh-jda-nlb-usl-3-z-4-m-xi-jy.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-6-l-exh-jda-nlb-usl-3-z-4-m-xi-jy!./.cache/json/news-c-6-l-exh-jda-nlb-usl-3-z-4-m-xi-jy.json
// module chunks = 231608221292675